'use strict';

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('./util'),
    get = _require.get,
    arr = _require.arr,
    px = _require.px,
    neg = _require.neg,
    num = _require.num,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

var _require2 = require('./constants'),
    space = _require2.space;

var REG = /^[mp][trblxy]?$/;

module.exports = function (props) {
  var keys = (0, _keys2.default)(props).filter(function (key) {
    return REG.test(key);
  }).sort();
  var bp = breaks(props);
  var sc = get(props, 'theme.space', space);

  return keys.map(function (key) {
    var val = props[key];
    var p = getProperties(key);

    if (!Array.isArray(val)) {
      return p.reduce(function (a, b) {
        return (0, _assign2.default)(a, (0, _defineProperty3.default)({}, b, mx(sc)(val)));
      }, {});
    }

    return arr(val).map(mx(sc)).map(dec(p)).map(media(bp)).reduce(merge, {});
  }).reduce(merge, {});
};

var mx = function mx(scale) {
  return function (n) {
    if (!num(n)) {
      return n;
    }

    var value = scale[Math.abs(n)] || Math.abs(n);
    if (!num(value)) {
      return value;
    }

    return px(value * (neg(n) ? -1 : 1));
  };
};

var getProperties = function getProperties(key) {
  var _key$split = key.split(''),
      _key$split2 = (0, _slicedToArray3.default)(_key$split, 2),
      a = _key$split2[0],
      b = _key$split2[1];

  var prop = properties[a];
  var dirs = directions[b] || [''];
  return dirs.map(function (dir) {
    return prop + dir;
  });
};

var properties = {
  m: 'margin',
  p: 'padding'
};

var directions = {
  t: ['Top'],
  r: ['Right'],
  b: ['Bottom'],
  l: ['Left'],
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/space.js
// module id = 386
// module chunks = 168707334958949